<template>
  <div class="schedule-page">
    <h2 class="page-title-cn">活动日程安排</h2>
    <h1 class="page-title">Event Schedule</h1>
    
    <!-- 2026年3月25日 -->
    <div class="day-section">
      <div class="date-header">
        <div class="date-cn">2026年3月25日</div>
        <div class="date-en">March 25, 2026</div>
      </div>
      <div class="timeline">
        <div class="event-card">
          <div class="event-header">
            <div class="time">09:00-10:00</div>
            <div class="event-tag">· 闭门会议 <span>Closed-door Meeting</span></div>
          </div>
          <div class="event-body">
            <div class="event-name">中国氢能联盟理事会会议(受邀出席)</div>
            <div class="event-name-en">CHA Council Meeting (By Invitation Only)</div>
            <div class="event-location">
              <img :src="dwIcon" alt="" class="loc-icon" />
              <div class="loc-text">
                <div>国家会议中心 二期2层222、224</div>
                <div class="loc-en">Room 222、224, Level 2, China National Convention Center (Phase II)</div>
              </div>
            </div>
          </div>
        </div>
        <div class="event-card">
          <div class="event-header">
            <div class="time">10:00-12:30</div>
            <div class="event-tag">· 开幕式 <span>Opening Ceremony</span></div>
          </div>
          <div class="event-body">
            <div class="event-name">CIHC2026国际氢能大会暨“十五五”氢能产业发展论坛</div>
            <div class="event-name-en">CIHC 2026 & the“15th Five-Year Plan”Hydrogen Development Forum</div>
            <div class="event-location">
              <img :src="dwIcon" alt="" class="loc-icon" />
              <div class="loc-text">
                <div>国家会议中心 二期2层223</div>
                <div class="loc-en">Room 223, Level 2, China National Convention Center (Phase II)</div>
              </div>
            </div>
          </div>
        </div>
        <div class="event-card">
          <div class="event-header">
            <div class="time">14:00-17:00</div>
            <div class="event-tag">· 专题会议1 <span>Thematic Session I</span></div>
          </div>
          <div class="event-body">
            <div class="event-name">绿氢交易国际合作论坛</div>
            <div class="event-name-en">International Green Hydrogen Trading & Cooperation Forum</div>
            <div class="event-location">
              <img :src="dwIcon" alt="" class="loc-icon" />
              <div class="loc-text">
                <div>国家会议中心 二期2层223</div>
                <div class="loc-en">Room 223, Level 2, China National Convention Center (Phase II)</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 2026年3月26日 -->
    <div class="day-section">
      <div class="date-header">
        <div class="date-cn">2026年3月26日</div>
        <div class="date-en">March 26, 2026</div>
      </div>
      <div class="timeline">
        <div class="event-card">
          <div class="event-header">
            <div class="time">09:30-17:00</div>
            <div class="event-tag">· 专题会议2 <span>Thematic Session II</span></div>
          </div>
          <div class="event-body">
            <div class="event-name">氢能产融创新合作论坛</div>
            <div class="event-name-en">Hydrogen Industry-Finance Innovation & Cooperation Forum</div>
            <div class="event-location">
              <img :src="dwIcon" alt="" class="loc-icon" />
              <div class="loc-text">
                <div>国家会议中心一期1层氢创未来厅</div>
                <div class="loc-en">Hydrogen Innovation Hall, Level 1, China National ConventionCenter (Phase I)</div>
              </div>
            </div>
          </div>
        </div>
        <div class="event-card">
          <div class="event-header">
            <div class="time">09:30-12:00</div>
            <div class="event-tag">· 边会 <span>Side Event</span></div>
          </div>
          <div class="event-body">
            <div class="event-name">绿氢耦合化工创新论坛</div>
            <div class="event-name-en">Green Hydrogen-Chemical IndustryIntegration Innovation Forum</div>
            <div class="event-location">
              <img :src="dwIcon" alt="" class="loc-icon" />
              <div class="loc-text">
                <div>国家会议中心二期2层212</div>
                <div class="loc-en">Room 212, Level 2, China National Convention Center (Phase II)</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 返回按钮 -->
    <div class="back-btn-wrap">
      <van-button type="primary" round @click="goBack" class="back-btn">返  回<br />
                  <span class="btn-en">Back</span></van-button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import dwIcon from '@/assets/dwicon.png'

const router = useRouter()
const store = useStore()

const mainColor = computed(() => store.state.mainColor)

const goBack = () => {
  router.back()
}
</script>

<style lang="less" scoped>
.schedule-page {
  padding: 5vw 4vw;
  background-image: url('~@/assets/bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  box-sizing: border-box;

  .page-title-cn {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    color: #fff;
    margin-bottom: 8px;
  }

  .page-title {
    text-align: center;
    font-size: 18px;
    font-weight: normal;
    color: #fff;
    margin-bottom: 5vw;
    letter-spacing: 2px;
  }

  .day-section {
    margin-bottom: 6vw;

    .date-header {
      margin-bottom: 4vw;
      text-align: left;
      .date-cn {
        font-size: 26px;
        font-weight: bold;
        color: #fff;
      }
      .date-en {
        font-size: 18px;
        color: #fff;
        margin-top: 4px;
      }
    }
  }

  .timeline {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .event-card {
    background: #fff;
    border-radius: 12px;
    border: 2px solid #5a9fff;
    overflow: hidden;

    .event-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 16px;
      background-color: #003df2;
      border-radius: 10px;
      margin-top: 10px;
      width: 90%;
      margin-left: auto;
      margin-right: auto;

      .time {
        font-size: 16px;
        color: #fff;
        font-weight: 600;
      }

      .event-tag {
        font-size: 13px;
        color: #fff;
        span {
          color: #fff;
          font-size: 12px;
        }
      }
    }

    .event-body {
      padding: 14px 16px;

      .event-name {
        font-size: 16px;
        color: #333;
        font-weight: 600;
        line-height: 1.5;
        text-align: left;
      }

      .event-name-en {
        font-size: 13px;
        color: #666;
        margin-top: 4px;
        text-align: left;
      }

      .event-location {
        display: flex;
        align-items: flex-start;
        margin-top: 12px;

        .loc-icon {
          width: 14px;
          height: 14px;
          margin-right: 6px;
          margin-top: 3px;
          flex-shrink: 0;
        }

        .loc-text {
          font-size: 13px;
          color: #666;
          text-align: left;
          .loc-en {
            font-size: 12px;
            color: #999;
            margin-top: 2px;
          }
        }
      }
    }
  }

  .back-btn-wrap {
    text-align: center;
    margin-top: 8vw;
    padding-bottom: 5vw;

    .van-button {
      width: 50vw;
    }

    .back-btn {
      background-color: #fff !important;
      color: #003df2 !important;
      border: 1px solid #003df2 !important;
      border-radius: 10px !important;
    }
  }
}

@media screen and (min-width: 768px) {
  .schedule-page {
    max-width: 800px;
    margin: 0 auto;
    padding: 30px 20px;

    .page-title {
      font-size: 24px;
      margin-bottom: 30px;
    }

    .day-section {
      margin-bottom: 40px;

      .date-header {
        .date-cn {
          font-size: 26px;
        }
        .date-en {
          font-size: 16px;
        }
      }
    }

    .event-card {
      .event-header {
        .time {
          font-size: 18px;
        }
      }

      .event-body {
        padding: 16px 20px;

        .event-name {
          font-size: 17px;
        }
      }
    }

    .back-btn-wrap {
      margin-top: 40px;

      .van-button {
        width: 200px;
      }
    }
  }
}
</style>
